var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 17,
    viewBox: "0 0 12 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1667 10.1667C11.3087 10.1666 11.4483 10.1303 11.5723 10.0611C11.6963 9.99188 11.8005 9.89216 11.8752 9.77136C11.9498 9.65056 11.9923 9.5127 11.9987 9.37085C12.0051 9.229 11.9751 9.08787 11.9117 8.96085L10.4317 6.00002L11.9117 3.03919C11.9751 2.91217 12.0051 2.77104 11.9987 2.62919C11.9923 2.48734 11.9498 2.34948 11.8752 2.22868C11.8005 2.10789 11.6963 2.00816 11.5723 1.93897C11.4483 1.86979 11.3087 1.83343 11.1667 1.83335H1.99999V1.00002C1.99999 0.779007 1.9122 0.567045 1.75592 0.410765C1.59964 0.254484 1.38768 0.166687 1.16666 0.166687C0.945648 0.166687 0.733686 0.254484 0.577406 0.410765C0.421126 0.567045 0.333328 0.779007 0.333328 1.00002V16C0.333328 16.221 0.421126 16.433 0.577406 16.5893C0.733686 16.7456 0.945648 16.8334 1.16666 16.8334C1.38768 16.8334 1.59964 16.7456 1.75592 16.5893C1.9122 16.433 1.99999 16.221 1.99999 16V10.1667H11.1667Z",
    fill: "#29C67B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenFlag);
export default __webpack_public_path__ + "static/media/green-flag.0147fc8a7927d27738677ebaf0e02c97.svg";
export { ForwardRef as ReactComponent };